module.exports = "img {\n  max-width: 400px;\n}\n"